$(document).on('click', '[data-object-select]', function (event) {
  event.preventDefault();
  $.ajax({
    method: 'GET',
    url: $(this).attr('href'),
  }).done((resp) => {
    const element = $(resp).appendTo($('body'));
    element.foundation().foundation('open');
  });
});
